import { ref, remove, get, update } from "firebase/database";
import { database } from "../../../../Utils/firebase";
import GetProformaInvoiceDataFirebase from "../../ProformaInvoice/GetProformaInvoiceDataFirebase";

const DeleteAssignerUserProformaInvoiceDataInFirebase = async (state, dispatch, uniqueID, userID, ownerUid) => {
    if (!ownerUid) return null;

    

    try {

        // Reference to the specific invoice in Firebase
        const userRef = ref(database, `invoiceGenerator/users/${ownerUid}/proforma/${uniqueID}`);

        const snapshot = await get(userRef);
        if (!snapshot.exists()) {
            return { success: false, message: "Proforma invoice not found." };
        }

        // Instead of deleting, just mark as deleted
        await update(userRef, { isDeleted: true,
            deletedBy: state?.USERID || "guest" });

        // Fetch updated invoice data after deletion
        await GetProformaInvoiceDataFirebase(state, dispatch);

        return { success: true, message: "Proforma Invoice deleted successfully!" };
    } catch (error) {
        return { success: false, message: error.message || "Failed to delete Proforma invoice." };
    }
};

export default DeleteAssignerUserProformaInvoiceDataInFirebase;
